

import { facebookLoginHandler } from "./platforms/facebook";
import { youtubeLoginHandler } from "./platforms/youtube";
import { instagramLoginHandler } from "./platforms/instagram";

// export const handleSocialLogin = (platform) => {
//   return new Promise((resolve, reject) => {
//     switch (platform) {
//       case "facebook":
//         facebookLoginHandler(resolve, reject);
//         break;
//       case "youtube":
//         youtubeLoginHandler(resolve, reject);
//         break;
//       case "instagram":
//         instagramLoginHandler(resolve, reject);
//         break;
//       default:
//         console.error("Platform not supported");
//         reject(new Error("Platform not supported"));
//     }
//   });
// };

export const handleSocialLogin = (platform) => {
  return new Promise((resolve, reject) => {
    // Extract current redirect intent from URL if available
    const currentParams = new URLSearchParams(window.location.search);
    const flowIntent = currentParams.get("flowIntent") || "brandSnapshot";

    // Append intent as query param to redirect URI
    const postLoginRedirectUri = `${window.location.origin}/social-studio?flowIntent=${flowIntent}`;

    switch (platform) {
      case "facebook":
        facebookLoginHandler(resolve, reject, postLoginRedirectUri);
        break;
      case "youtube":
        youtubeLoginHandler(resolve, reject, postLoginRedirectUri);
        break;
      case "instagram":
        instagramLoginHandler(resolve, reject, postLoginRedirectUri);
        break;
      default:
        console.error("Platform not supported");
        reject(new Error("Platform not supported"));
    }
  });
};


